import { Controller } from "@hotwired/stimulus"

// Handles dropdown behavior
export default class extends Controller {
  connect() {
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      // Find and remove focus from any focused elements within the dropdown
      const focused = this.element.querySelector('[tabindex="0"]:focus')
      if (focused) focused.blur()
    }
  }
} 